module.exports = __webpack_public_path__ + "static/media/X.ca9e4096.svg";